<template>
    <div class="tw:space-y-4">
        <div class="tw:mb-4">
            <h2 class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:my-1">
                Foto del deportista
            </h2>
        </div>

        <div>
            <Dropzone
                :url="uploadUrl"
                :current-image="value.foto_perfil"
                :preview="value.foto_perfil"
                @success="onUploadSuccess"
            />
        </div>
    </div>
</template>

<script setup>
    import Dropzone from '@/modules/admin/ui/Dropzone.vue';

    const props = defineProps({
        value: { type: Object, required: true },
        uploadUrl: { type: String, required: true },
    });

    const emit = defineEmits(['upload-success']);

    function onUploadSuccess(file, response) {
        emit('upload-success', response);
    }
</script>
